
export { g as getVisitId } from "./index-ffec2ddf.js"